export function responsivePropToArrayOrObject(prop) {
  return typeof prop === 'object' ? Array.isArray(prop) ? prop : prop : [prop, prop];
}